import React, {ReactElement} from "react";
import styles from "../AnalystPayrollDrawer.module.scss";
import {Field, Input, Label} from "@zendeskgarden/react-forms";
import {Col, Row} from "@zendeskgarden/react-grid";
import {
    LocalPayrollEmployeeModel,
    LocalPayrollEmployeeModelKeys, LocalPayrollEmployeeOvertimeModel
} from "../helpers/types";
import {Datepicker} from "@zendeskgarden/react-datepickers";
import {Button} from "@zendeskgarden/react-buttons";
import {DateFormatter} from "../helpers/utils";
import {ensureDateInLocale, ensureDateInUtc} from "../date-helpers";
import PayrollDatePicker from "./PayrollDatePicker";
import { useProperties } from "../../../contexts/properties/PropertiesContext";

interface OvertimeEntryProps {
    index: number,
    overtime: LocalPayrollEmployeeOvertimeModel,
    allowRemove: boolean,
    employeeData: LocalPayrollEmployeeModel,
    updateFormState: (key: LocalPayrollEmployeeModelKeys, value: any) => void
}

export default function OvertimeEntry({index, overtime, allowRemove, employeeData, updateFormState}: OvertimeEntryProps): ReactElement {
    const {currentProperty} = useProperties();
    return (
        <div style={{display: "block"}}>
            <Row justifyContent="between">
                <Col>
                    <Label className={styles.earningsSubHeaders}>Overtime {index + 1}</Label>
                </Col>
                {
                    allowRemove && <Button isBasic isDanger onClick={() => {
                        updateFormState(LocalPayrollEmployeeModelKeys.removeOvertime, index);
                    }}>Remove</Button>
                }
            </Row>
            <Row justifyContent="between">
                <Col>
                    <Field className={styles.field}>
                        <Label className={styles.label}>Hourly Rate</Label>
                        <Input placeholder="$" value={overtime.hourlyCompensation}
                               type={"number"}
                               onChange={(evt) => {
                                   updateFormState(LocalPayrollEmployeeModelKeys.overtimesHourlyRate, evt.target.value);
                               }}
                        />
                    </Field>
                </Col>
                <Col>
                    <Field className={styles.field}>
                        <Label className={styles.label}>Hours/Week</Label>
                        <Input placeholder="Hours" value={overtime.expectedHoursPerWeek}
                               type={"number"}
                               onChange={(evt) => {
                                   updateFormState(LocalPayrollEmployeeModelKeys.overtimeHoursPerWeek, evt.target.value);
                               }}
                        />
                    </Field>
                </Col>
            </Row>
            <Row justifyContent="between">
                <Col>
                    <Field className={styles.field}>
                        <Label className={styles.label}>Start Date</Label>
                        <PayrollDatePicker
                            maxDate={overtime.effectiveEndDate ?? ""}
                            dateValue={(overtime.effectiveStartDate ?? employeeData.startDate) ?? ""}
                            onDateChange={(newDate) => {
                                if (currentProperty?.isAcquisitionProperty) {
                                    updateFormState(LocalPayrollEmployeeModelKeys.overtimeStartDate, newDate);
                                } else {
                                    updateFormState(LocalPayrollEmployeeModelKeys.overtimeStartDate, ensureDateInUtc(newDate)?.toISOString());
                                }
                            }}
                        />
                    </Field>
                </Col>
                <Col>
                    <Field className={styles.field}>
                        <Label className={styles.label}>End Date</Label>
                        <PayrollDatePicker
                            minDate={overtime.effectiveStartDate ?? ""}
                            dateValue={(overtime.effectiveEndDate ?? employeeData.terminationDate) ?? ""}
                            onDateChange={(newDate) => {
                                if (currentProperty?.isAcquisitionProperty) {
                                    updateFormState(LocalPayrollEmployeeModelKeys.overtimeEndDate, newDate);
                                } else {
                                    updateFormState(LocalPayrollEmployeeModelKeys.overtimeEndDate, ensureDateInUtc(newDate)?.toISOString());
                                }
                            }}
                        />
                    </Field>
                </Col>
            </Row>
        </div>
    );
}

